import * as React from "react";
import type { SVGProps } from "react";
const SvgPlay03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M18.144 10.867c1.405.812 1.41 1.833 0 2.752l-10.9 7.623c-1.37.758-2.3.31-2.397-1.33L4.8 3.958C4.77 2.447 5.97 2.02 7.113 2.744z"
    />
  </svg>
);
export default SvgPlay03;
